import {
  getRegisteredPrimaryActions,
  getRegisteredNavGroups,
  getRegisteredSettingsItem,
  getRegisteredMarketplaceItem,
  getRegisteredShellRouteDefs,
  type NavItem,
  type NavGroup,
} from "@/routes/registry";

export type { NavItem, NavGroup };

/** Primary actions at the top of the sidebar. */
export const primaryActions: NavItem[] = getRegisteredPrimaryActions();

/** The main navigation groups composed from per-feature modules. */
export const navGroups: NavGroup[] = getRegisteredNavGroups();

export const settingsItem: NavItem = getRegisteredSettingsItem();

/** The low-frequency Marketplace destination in the sidebar footer. */
export const marketplaceItem: NavItem = getRegisteredMarketplaceItem();

/** Every page the shell can land on, so an unknown address still falls through to not found. */
export const shellRoutes: { path: string; title: string; summary: string; end?: boolean }[] =
  getRegisteredShellRouteDefs();
